export default {
    regionsResult: { list: [], edit: { id: -1, name: '' } }
};
